import { toast } from '@randstad-lean-mobile-factory/react-components-core';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { RightsService, UnitaryRight } from 'src/Services/API';

import { useAuth } from '../Authentication/useAuth';
import { QueryKeys } from '../types';

export const useFetchUserUnitaryRights = (
  extraOptions?: UseQueryOptions<UnitaryRight[], AxiosError>
) => {
  const { isAuthenticated } = useAuth();

  return useQuery<UnitaryRight[], AxiosError>(
    [QueryKeys.fetchUserUnitaryRights],
    async () => {
      return await RightsService.rightsControllerGetUserUnitaryRights();
    },
    {
      onError: (error: AxiosError) => {
        switch (error.response?.status) {
          default:
            toast.error('erreur lors de la récupération des droits');
        }
      },
      enabled: isAuthenticated,
      staleTime: 300000,
      cacheTime: 300000,
      refetchOnWindowFocus: false,
      ...extraOptions,
    }
  );
};
